/**
 * VERSIONE LIBRERIA 3
 */
var RenderHasmanyThrough = Render.extend({
    type : 'hasmany_through',
    classData : 'hasmany_through',
    classTemplate : 'hasmany_through',
    selected : [],
    modelName : "none",
    last_searched_result : null,  // json risultato dell'ultima ricerca
    hasmany_container : '[data-hasmany_container]',
    selected_container : '[data-selected_container]',
    title_selector : '[data-render_title]',
    autocompleteModel : null,
    morph : null,
    label_field : null,
    addNew : false,
    searchField : null,
    searchDescription : null,
    itemAddTemplate : null,
    itemViewTemplate : null,
    listItemsTemplate : null,

    init: function (key,config) {
        this._super(key,config);
        this.selected = [];
        this.last_searched_result = null;
        if (!this.itemViewTemplate)
            this.itemViewTemplate = '#' + this.prefixTemplateClass + '_hasmany_through_view_item_tpl';
        if (!this.itemAddTemplate)
            this.itemAddTemplate = '#' + this.prefixTemplateClass + '_hasmany_through_addeditem_tpl';
        if (!this.listItemsTemplate)
            this.listItemsTemplate = '#' + this.prefixTemplateClass + '_hasmany_through_listitem_tpl';
    },

    _renderView : function (jQe) {
        var self = this;
        //log.info("RenderHasmany view ", self.data);
        if (self.value && self.value.length > 0) {
            var tpl = self.itemViewTemplate;
            for (var i in self.value) {
                var fields = self.fields ? self.fields:[];
                var itemData = _.omit(self.value[i],['pivot']);
                if (self.fields && self.fields.length > 0) {
                    itemData = _.pick(itemData,self.fields);
                }
                var items = [];
                var itemsByKey = {}; // accesso con key per dati conosciuti
                // items e' in fomato vettore per poterci accedere items[n].key item[n].value in caso
                // di dati non conosciuti a priori

                for (var k in itemData) {
                    items.push({key:k,value:itemData[k]})
                    itemsByKey[k] = itemData[k];
                }
                var tplData = {
                    items : items,
                    itemsByKey : itemsByKey
                }
                var html = $.getTemplate(tpl,tplData);
                $(jQe).find('[data-render_list]').append(html);
            }
            return ;

        }
    },
    _finalizeView : function () {

    },
    _renderEdit : function (jQe) {
        var self = this;
        jQe.find(self.hasmany_container).attr('data-hasmany_container',self.key);
        jQe.find(self.selected_container).attr('data-selected_container',self.autocompleteModel);
        jQe.find(self.title_selector).html($.translate('model-'+self.autocompleteModel));
        var exists = self.key + "_exists";
        $('<input>').attr({
            type: 'hidden',
            name: exists,
            value : 1
        }).appendTo(jQe);
    },
    _finalizeEdit : function () {
        var self = this;
        self.selected = [];
        $.translateDocument(self.container);
        log.debug('hasmany_through',self.value,self.config);
        var morph_id = null;
        var morph_type = null;
        for (var i in self.value) {
            var item = self.value[i];
            var id = item.id;
            //log.debug("Item: ",item);
            if (self.morph) {
                morph_id = item[self.morph.id];
                morph_type = item[self.morph.type];
                id = morph_type + '_' + morph_id
            }
            self._addItem(id, item[self.label_field], morph_type, morph_id,item);
        }

        self._populate("");
        //var modelName = Utility.camelCase(self.model.resultParams[self.key].modelName);


        $(self.container).find('[data-search]').change(function () {
            self._populate($(this).val());
        });
        if (self.addNew) {

            $(self.container).find('[data-button_add]').click(function () {
                log.info("insert " + self.modelName);
                var tplView = "<viewinsert id='addnewView' model='" + self.modelName + "'></viewinsert>";
                $('#generalDialog .modal-body').html(tplView);
                Facade.parse('#generalDialog .modal-body');
                var keyId = Facade.getKeyFromId('addnewView');
                $.generalDialog(null,{btok_label:"Salva"}).ok(function () {
                    alert('keyid' + keyId);
                    Facade.controller.actionSave(keyId,null,{},function (json) {
                        Facade.removeView(keyId);
                        if (json.error) {
                            $.errorDialog(json.msg);
                            return ;
                        }
                        self.container.find('[data-search]').trigger('change');
                    });
                }).cancel(function () {
                    Facade.removeView(keyId);
                })
            })
        } else {
            $(self.container).find('[data-button_add]').addClass('hide');
        }
        $(self.container).find(".sort_class").sortable({
            handle: '.button-move',
        });
    },
    _populate : function (filter) {
        var self = this;
        var list_container = $(self.container).find('[data-hasmany_container="'+ self.key +'"]');
        // unbind vecchi click
        $(list_container).find('[data-add]').unbind('click');
        $(list_container).html($('#default_spinner_tpl').html());
        //$.waitStart();
        var url = null;
        var morph = self.morph;
        var label_field = self.label_field;
        var url = "/api/json/autocomplete/"+self.autocompleteModel+"?term="+filter;
        if (self.search_field)
            url += "&field="+self.search_field;
        if (self.search_description)
            url += "&description="+self.search_description;
        if (self.metodo)
            url += "&method="+self.metodo;

        $.get(Facade.getUrl(url),function (json) {
            if (json.error) {
                $.errorDialog(json.msg);
                return ;
            }
            delete self.last_searched_result;
            self.last_searched_result = json.result;

            $.renderTemplate(self.listItemsTemplate,list_container,json.result);
            $(list_container).find('[data-add]').click(function () {
                if (morph) {
                    var id = $(this).data('morph_type') + '_' + $(this).data('morph_id');
                } else {
                    var id = $(this).data('id');
                }
                var el = json.result.find(function (o) { return o.id == id; });
                var data = el  && el.data?el.data:null;
                self._addItem(id,$(this).data('label'),$(this).data('morph_type'),$(this).data('morph_id'),data);
            });
        }).fail(function (e) {
            log.error(e);
            $.errorDialog($.getFailMessage(e) );
        })
    },
    _addItem : function (id,label,morph_type,morph_id,json) {
        var self = this;
        if (!isNaN(id)) {
            id = parseInt(id);
        }

        if ($.inArray(id,self.selected) >= 0) {   // elemento gia' inserito
            return false;
        }
        log.debug("Add item id: ",id);
        self.selected.push(id);
        //var modelName = Utility.camelCase(self.model.resultParams[self.key].modelName);
        //console.log('added_container',self.container,'[data-selected_container="'+ self.modelName +'"]');
        var added_container = $(self.container).find('[data-selected_container="'+ self.autocompleteModel +'"]');
        //console.log(added_container.length,' added containet',added_container);
        if (!json) {
            for (var i in self.last_searched_result) {
                if (morph_id) {
                    //console.log('check',self.last_searched_result[i].morph_id,morph_id,self.last_searched_result[i].morph_type,morph_type);
                    if ( self.last_searched_result[i].morph_id == morph_id &&
                        self.last_searched_result[i].morph_type == morph_type  ) {
                        json = self.last_searched_result[i].data;
                        break;
                    }
                } else {
                    if ( self.last_searched_result[i].id == id) {
                        json = self.last_searched_result[i].data;
                        break;
                    }
                }

            }

            if (!json) {// non ho trovato nulla
                json = {};
                log.warn("nono trovato nulla " + id)
            }
        }

        //var json = {'id': id,label:label,status:"new",'morph_type':morph_type,'morph_id':morph_id};
        // setto i valori necessari per l'item oltre a quelli opzionali dell'intero modello
        json.id = id;
        json.label = label;
        json.status = 'new';
        json.morph_type = morph_type;
        json.morph_id = morph_id;
        json.morph = false;
        if (self.morph)
            json.morph = true;
        // prendo il template per un nuovo item
        var obj = $.createDynamicContainer(self.itemAddTemplate);
        //var old_html = $(added_container).html();
        $.renderTemplate(obj,obj,json);
        // assegno i nomi giusti dei campi nascosti per la form
        // tenendo conto se si trova in un hasmany il nome di vettore e' composto diversamente
        $.each(obj.find('input,textarea,select'), function (k, nameval) {
            var name = self._getFieldName($(this).data('field'));
            $(this).attr('name', name);
        });
        //console.log('html',obj.html())
        // aggiorno l'html della lista con il nuovo elemento
        //$(added_container).html(old_html+obj.html());
        $(added_container).append(obj.html());
        obj.remove();
        // assegno gli eventi per la delete dell'oggetto
        $(added_container).find('[data-button_delete]').unbind('click');
        $(self.container).find('[data-button_delete]').click(function () {
            var index = $(this).closest("[data-hasmany_through_item]").index();
            self._deleteItem(index);
        });
        // trigger che sono stati modificati i valori
        $(self.container).find('[data-control_container="'+ self.key +'"]').trigger('change',[$(this)]);


    },
    _deleteItem : function (index) {
        var self = this;
        //console.log(self.selected);
        //var modelName = Utility.camelCase(self.model.resultParams[self.key].modelName);
        var added_container = $(self.container).find('[data-selected_container="'+ self.autocompleteModel +'"]');
        //console.log(self.container,'[data-selected_container="'+ self.modelName +'"]','[data-hasmany_through_item]:eq('+index+')','input[name="'+ self.key+ '-id[]"]');
        var fieldName = self._getFieldName('id');
        var item_id = $(added_container).find('[data-hasmany_through_item]:eq('+index+')').find('input[name="'+ fieldName + '"]').val();
        if (!isNaN(item_id)) {
            item_id = parseInt(item_id);
        }
        if (!item_id) {
            log.warn("_deleteItem " + self.key + " index container " + index + " id non valido " + item_id );
            log.warn('selected item ',self.selected);
            log.warn('find rule is ',self.container,'[data-selected_container="'+ self.autocompleteModel +'"]','[data-hasmany_through_item]:eq('+index+')','input[name="'+ self.key+ '-id[]"]');
            return ;
        }
        self.selected = _.without(self.selected, item_id );
        //log.info(self.selected);
        $(added_container).find('[data-hasmany_through_item]:eq('+index+')').remove();
        $(self.container).find('[data-control_container="'+ self.key +'"]').trigger('change',[$(this)]);

    },
    // assegno i nomi giusti dei campi nascosti per la form
    // tenendo conto se si trova in un hasmany il nome di vettore e' composto diversamente
    _getFieldName : function (field) {
        var self = this;
        var basename = self.key;
        var arrayname = "";
        if (self.key.indexOf('[') >= 0) {
            var basename = self.key.substr(0,self.key.indexOf('['));
            var arrayname = self.key.substr(self.key.indexOf('['));
        }
        var name = basename+"-"+field+arrayname+"[]";
        return name;
    }
});